<template>
  <div class="relative grow flex justify-center py-6">
    <div class="light-grid absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]" style="background-position: 10px 10px;"></div>

    <div class="max-w-[120.25rem] w-full flex flex-col border border-gray-200 overflow-hidden rounded-lg bg-white z-10">
      <div class="flex grow">
        <EmailOptions v-model="emailObj"/>
        <div class="grow relative">
          <RawHtml :value="templateContent" @save="newHtml => newContent = newHtml" :remove-tailwind-alert="true" ref="editor"/>
        </div>
      </div>
      <div class="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
        <div class="flex justify-end space-x-3">
          <button type="button" class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" @click="resetTemplateContent">
            Reset template content
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

import EmailOptions from "./EmailOptions"
import RawHtml from "@/components/SideEditor/BlockConfigurationTabs/CmsRichTextEditor/RawHtml"

export default {
  props: ['template', 'orig_template_code', 'template_subject', 'id', 'default'],
  components: {
    EmailOptions,
    RawHtml,
  },
  data() {
    return {
      emailObj: {
        orig_template_code: this.orig_template_code || "design_email_header_template",
        template_subject: this.template_subject,
      },
      templateContent: this.template,
      newContent: this.template,
    }
  },
  created() {
    this.updateConfig()
  },
  methods: {
    resetTemplateContent() {
      this.templateContent = this.default.template
      this.newContent = this.default.template
      this.$refs.editor.reset()
    },
    updateConfig() {
      if (!this.id) return;
      const options = this.emailObj
      this.$store.commit("editor/config", {
        email_templates: {
          [this.id]: {
            ...options,
            template_code: this.id,
            template: this.newContent,
          },
        },
      })
    },
  },
  watch: {
    newContent() {
      this.updateConfig()
    },
    emailObj() {
      this.updateConfig()
    },
  },
}

</script>
